var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.79311 0.35282C1.40297 -0.0380277 0.766135 -0.0422722 0.370699 0.34334C-0.0247377 0.728952 -0.029032 1.3584 0.361107 1.74924L15.6513 17.0672L0.376071 32.3582C-0.0142195 32.7489 -0.00992988 33.3781 0.385652 33.7636C0.781234 34.1491 1.41831 34.1448 1.8086 33.7541L17.0642 18.4827L32.3207 33.7669C32.7109 34.1578 33.3477 34.162 33.7431 33.7764C34.1386 33.3908 34.1429 32.7613 33.7527 32.3705L18.4777 17.0678L33.7809 1.7488C34.1712 1.3581 34.1669 0.728903 33.7713 0.343436C33.3757 -0.0420307 32.7387 -0.037794 32.3484 0.352899L17.0648 15.6523L1.79311 0.35282Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.c8c22817.svg";
export { ForwardRef as ReactComponent };